import { SERVICES } from '../mock';

// Extract a numeric dollar amount from a price string like "$60.00" or "From $80.00".
// Returns null when there is no concrete amount (e.g. "Varies", "Quoted on arrival").
export const parsePrice = (price) => {
  const match = price.match(/\$\s*([\d,.]+)/);
  return match ? parseFloat(match[1].replace(/,/g, '')) : null;
};

// Services that have a concrete dollar amount and can therefore be pre-filled on the pay page.
export const PAYABLE_SERVICES = SERVICES
  .map((s) => ({ ...s, amount: parsePrice(s.price) }))
  .filter((s) => s.amount != null);

// Normalize a raw amount input into a valid, positive number (0 when invalid).
export const toValidAmount = (value) => {
  const val = parseFloat(value);
  return Number.isFinite(val) && val > 0 ? val : 0;
};

// Format a number as USD currency for display.
export const formatUSD = (amount) =>
  amount > 0 ? amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '$0.00';
